import {observable, makeObservable} from 'mobx';

import {DatetimeUtils} from "../../infrastructure/utils/datetime-utils";
import {LocalStorageUtils} from '../../infrastructure/utils/local-storage.utils';
import {IOC} from "../../infrastructure/ioc";
import {PredictionSelectionModel} from "../../infrastructure/models/schema/prediction-selection.model";
import {BaseManager} from "../../infrastructure/managers/base-manager";
import {DomUtils} from "../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../bootstrap/models/site-config";
import {DeviceStore} from "../app/device.store";
import {singleton} from "../../infrastructure/decorators/singleton";
import {LOCAL_STORAGE_KEYS} from "../consts";

@singleton
export class PredictionsSelectionsManager extends BaseManager {
  ioc: IOC;
  @observable selections: Array<PredictionSelectionModel>;

  static injectables = [...BaseManager.injectables, IOC];

  constructor(
    domUtils: DomUtils,
    logger: LoggerUtils,
    siteConfig: SiteConfig,
    deviceStore: DeviceStore,
    ioc: IOC) {
    super(domUtils, logger, siteConfig, deviceStore);

    this.ioc = ioc;

    this.selections = this.fetch();
    this.removeExpiredSelections();

    makeObservable(this);
  }

  get localStorageUtils(): LocalStorageUtils {
    return this.ioc.getInstance(LocalStorageUtils);
  }

  get datetimeUtils(): DatetimeUtils {
    return this.ioc.getInstance(DatetimeUtils);
  }

  fetch(): Promise<Array<PredictionSelectionModel>> {
    const selections: Array<Object> = this.localStorageUtils.get(LOCAL_STORAGE_KEYS.predictionSelection) || [];
    const selectionsVM: Array<PredictionSelectionModel> = selections.map((selection: PredictionSelectionModel) => {
      return new PredictionSelectionModel(selection.predictionId, selection.num, selection.date)
    });

    return selectionsVM;
  }

  add(predictionSelection: PredictionSelectionModel) {
    this.selections.push(predictionSelection);

    return this.localStorageUtils.set(LOCAL_STORAGE_KEYS.predictionSelection, this.selections);
  }

  removeExpiredSelections() {
    this.selections = this.selections.filter((selection: PredictionSelectionModel) => !this.isSelectionExpired(selection))

    return this.localStorageUtils.set(LOCAL_STORAGE_KEYS.predictionSelection, this.selections);
  }

  isSelectionExpired(selection: PredictionSelectionModel): Boolean {
    let isExpired: Boolean = false;

    if(selection.date) {
      const date = this.datetimeUtils.fromISO(selection.date);
      const countDaysFromToday = this.datetimeUtils.diffDaysByDate(date);
      isExpired = countDaysFromToday < -14;
    }

    return isExpired;
  }
}
